import React from "react";
import { useSelector } from "react-redux";
import clsx from "clsx";
import PropTypes from "prop-types";
import { Tabs as MuiTabs, Tab, IconButton, Box } from "@material-ui/core";

import useStyles from "./styles";

import { PlusIcon, CloseXIcon } from "../../../../../assets/icons";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div hidden={value !== index} id={`tabpanel-${index}`} {...other}>
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const Tabs = ({ tabs, value, onChange, onAdd, onRemove }) => {
  const { isDarkMode } = useSelector((state) => state.theme);

  const styles = useStyles({ isDarkMode });

  return (
    <div className={styles.root}>
      <MuiTabs
        value={value}
        onChange={onChange}
        aria-label="custom tabs"
        className={styles.tabs}
        TabIndicatorProps={{ style: { display: "none" } }}
      >
        {tabs.map((tab, idx) => (
          <div key={tab.label} className={styles.tabWrapper}>
            <Tab
              icon={
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    onRemove(idx);
                  }}
                  className={styles.closeIcon}
                  aria-label={`close tab ${tab.label}`}
                >
                  <CloseXIcon width="16" height="16" />
                </IconButton>
              }
              onClick={() => onChange(null, idx)}
              label={<span className={styles.tabLabel}>{tab.label}</span>}
              className={clsx(styles.tab, {
                [styles.selectedTab]: value === idx,
              })}
            />
          </div>
        ))}
        <div className={styles.addTabWrapper}>
          <IconButton
            size="small"
            onClick={onAdd}
            className={styles.addIcon}
            aria-label="add tab"
          >
            <PlusIcon width="20px" height={"20px"} />
          </IconButton>
        </div>
      </MuiTabs>
    </div>
  );
};

Tabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
};

export { TabPanel };
export default Tabs;
